import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { PublicAccessTerminalService } from '../shared/public-access-terminal.service';

@Injectable()
export class CivilPilotPatGuard implements CanActivate {

  constructor(private publicAccessTerminalService: PublicAccessTerminalService,
              private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const isPat = this.publicAccessTerminalService.isPublicAccessTerminal();

      if (!isPat) {
        this.router.navigateByUrl('/');
      }
      return isPat;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-pilot-pat.guard.ts